import { setPromocode } from '@/redux/order/slice'
import { useAppDispatch } from '@/redux/store'
import reachGoalMetrika from '@/utils/helpers/reach-goal-metrika.helper'
import axios from 'axios'
import { useRouter } from 'next/router'
import { useEffect } from 'react'

const usePromo = () => {
  const { query, isReady } = useRouter()

  const dispatch = useAppDispatch()

  useEffect(() => {
    const checkPromoCode = async () => {
      const keys = Object.keys(query)
      const hmsPromo = keys.find((key) => query[key] === '')

      if (hmsPromo) {
        dispatch(setPromocode(hmsPromo))
        reachGoalMetrika('promo_code_entered')
      }
      if (typeof query.ref === 'string') {
        try {
          await axios.get('https://my.majordomo.ru/status/go', {
            params: {
              ajax: true,
              ref: query.ref,
              go: 'https://www.majordomo.ru/?ref=' + query.ref,
            },
          })
        } catch (error) {
          console.error(error)
        }
      }
    }

    checkPromoCode()
  }, [isReady])

  return {}
}

export default usePromo
